/**
 * Validate user input against an exact command or regex pattern
 * @param {string} userInput - The input to be validated
 * @param {RegExp|string} expectedInput - The exact command or regex pattern
 * @returns {boolean} True if input matches, false otherwise
 */
function validateCommand(userInput, expectedInput) {
    
    // Handle null, undefined, or empty string cases
    if (userInput == null || userInput.trim() === '') {
        return false;
    }
    // Trim whitespace for consistency
    userInput = userInput.trim();
    // Case 1: Exact String Match (if expectedInput is a plain string)
    if (typeof expectedInput === "string" && !expectedInput.startsWith("^")) {
        const isExactMatch = userInput === expectedInput;
        return isExactMatch;
    }
    // Case 2: Regex Validation
    try {
        // Ensure expectedInput is a RegExp object
        const regex = expectedInput instanceof RegExp ? expectedInput : new RegExp(expectedInput);
        // Test the input against the regex
        const isMatch = regex.test(userInput);
        return isMatch;
    } catch (error) {
        return false;
    }
}

module.exports = validateCommand;